var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgUngroup = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.714 6c1.052 0 1.905.853 1.905 1.904v4.477h4.477c1.052 0 1.904.853 1.904 1.905v3.81A1.905 1.905 0 0 1 16.096 20H5.904A1.905 1.905 0 0 1 4 18.096V7.904C4 6.853 4.853 6 5.904 6zM6.19 13.62a.95.95 0 0 0-.952.951v3.242a.95.95 0 0 0 .952.949h3.24a.953.953 0 0 0 .952-.952v-3.24a.95.95 0 0 0-.952-.952H6.19Zm6.381 0a.95.95 0 0 0-.952.951v3.239c0 .526.426.952.952.952h3.239a.95.95 0 0 0 .952-.952v-3.24a.95.95 0 0 0-.952-.952h-3.24Zm-6.38-6.382a.95.95 0 0 0-.953.952v3.239c0 .526.427.952.952.952h3.24a.95.95 0 0 0 .952-.952V8.19a.95.95 0 0 0-.952-.952zM19 4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1zm-3.35 1.15a.5.5 0 0 0-.5.5v2.7a.5.5 0 0 0 .5.5h2.7a.5.5 0 0 0 .5-.5v-2.7a.5.5 0 0 0-.5-.5z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUngroup);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ungroup.48e294e4.svg";